export default __webpack_public_path__ + "static/media/vote-avatar.ccc3f913.png";